import React from 'react';
import Icon from '../../../components/AppIcon';

const ScorePreview = ({ score, maxScore = 1000 }) => {
  const percentage = (score / maxScore) * 100;

  const getScoreColor = () => {
    if (percentage >= 80) return 'from-[#10B981] to-[#059669]';
    if (percentage >= 60) return 'from-[#F59E0B] to-[#D97706]';
    return 'from-[var(--color-primary)] to-[var(--color-secondary)]';
  };

  const getScoreLabel = () => {
    if (percentage >= 80) return 'Excellent';
    if (percentage >= 60) return 'Good';
    if (percentage >= 40) return 'Fair';
    return 'Getting Started';
  };

  return (
    <div className="bg-gradient-to-br from-[var(--color-card)] to-[var(--color-muted)] rounded-2xl p-6 md:p-8 lg:p-10 border border-[var(--color-border)] shadow-lg">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-[var(--color-foreground)] mb-1">
            Your SocialCents Score
          </h3>
          <p className="text-sm md:text-base text-[var(--color-muted-foreground)]">
            Real-time preview based on your profile
          </p>
        </div>
        <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-full bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-secondary)] flex items-center justify-center">
          <Icon name="TrendingUp" size={24} color="#FFFFFF" />
        </div>
      </div>

      <div className="flex items-end gap-2 mb-4">
        <span className={`text-5xl md:text-6xl lg:text-7xl font-bold bg-gradient-to-r ${getScoreColor()} bg-clip-text text-transparent`}>
          {score}
        </span>
        <span className="text-2xl md:text-3xl lg:text-4xl text-[var(--color-muted-foreground)] mb-2">
          / {maxScore}
        </span>
      </div>

      <div className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm md:text-base text-[var(--color-muted-foreground)]">
            Score Level
          </span>
          <span className={`text-sm md:text-base font-semibold bg-gradient-to-r ${getScoreColor()} bg-clip-text text-transparent`}>
            {getScoreLabel()}
          </span>
        </div>
        <div className="w-full h-3 bg-[var(--color-muted)] rounded-full overflow-hidden">
          <div
            className={`h-full bg-gradient-to-r ${getScoreColor()} transition-all duration-500 rounded-full`}
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
        <div className="bg-[var(--color-background)]/50 rounded-lg p-3 md:p-4">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Users" size={16} color="var(--color-primary)" />
            <span className="text-xs md:text-sm text-[var(--color-muted-foreground)]">
              Reach
            </span>
          </div>
          <p className="text-base md:text-lg font-semibold text-[var(--color-foreground)]">
            {percentage >= 60 ? 'High' : percentage >= 40 ? 'Medium' : 'Growing'}
          </p>
        </div>
        <div className="bg-[var(--color-background)]/50 rounded-lg p-3 md:p-4">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Target" size={16} color="var(--color-secondary)" />
            <span className="text-xs md:text-sm text-[var(--color-muted-foreground)]">
              Engagement
            </span>
          </div>
          <p className="text-base md:text-lg font-semibold text-[var(--color-foreground)]">
            {percentage >= 60 ? 'Strong' : percentage >= 40 ? 'Good' : 'Building'}
          </p>
        </div>
        <div className="bg-[var(--color-background)]/50 rounded-lg p-3 md:p-4">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="DollarSign" size={16} color="var(--color-accent)" />
            <span className="text-xs md:text-sm text-[var(--color-muted-foreground)]">
              Earning Tier
            </span>
          </div>
          <p className="text-base md:text-lg font-semibold text-[var(--color-foreground)]">
            {percentage >= 80 ? 'Premium' : percentage >= 60 ? 'Plus' : 'Standard'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ScorePreview;